/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
import { handleExistingCommentList } from './../../../../SharedModules/CommonUtilities/commonUtilities';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformAdjustedResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_ADJUSTED_DISPLAY_OBJ_CLAIM,
  screenData: data,
});

export const setPaginationIndex = (value) => ({
  type: actionTypes.SET_PAGINATION_INDEX_ADJUTED_CLAIMS,
  payload: value,
});
export const setDrugSeqNumber = (value) => ({
  type: actionTypes.SET_DRUG_SEQ_NUMBER,
  drugSeqNumber: value,
});
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformAdjustedDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_ADJUSTED_DISPLAY_DETAIL_OBJ_CLAIM,
  detailScrData: data,
});

//  error msg dispatch function
export const dispatchErrorMsgAdjustedClaim = (data) => ({
  type: actionTypes.GET_ERROR_MSG_ADJUSTED_CLAIM,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  dispatch(
    dispatchErrorMsgAdjustedClaim({
      searchScreenErrors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const dispatchErrorMsgNDCDetail = (data) => ({
  type: actionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_CLAIM,
  payload: data,
});
// rebate programe Name dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_CLAIM,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DROPDN_REBATE)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

// unit changed type dispatch
export const dispatchUnitChangedType = (data) => ({
  type: actionTypes.SET_UNIT_CHANGED_TYPE,
  payload: data,
});
// dispute resolution dispatch
export const dispatchDisputeResolution = (data) => ({
  type: actionTypes.SET_DISPUTE_RESOLUTION,
  payload: data,
});
// invoice status dispatch
export const dispatchInvoiceStatus = (data) => ({
  type: actionTypes.SET_INVOICE_STATUS,
  payload: data,
});
// select by dispatch
export const dispatchSelectBy = (data) => ({
  type: actionTypes.SET_SELECT_BY,
  payload: data,
});
// labeler list dispatch
export const dispatchLabeler = (data) => ({
  type: actionTypes.SET_LABELER_LIST,
  payload: data,
});
export const getlabelerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_LABELER_LIST_DATA, value)
    .then((response) => {
      return dispatch(dispatchLabeler(response.data));
    })
    .catch((response) => {
      dispatch(dispatchLabeler([]));
    });
};
// refresh ndc details
export const refreshNDCDetailsAdjusted = () => ({
  type: actionTypes.REFRESH_NDC_DETAILS,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjAdjusted = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_ADJUSTED,
  payload: data,
});
// dispatch labeler data
export const dispatchLabelerData = (data) => ({
  type: actionTypes.SET_LABELER_DATA,
  payload: data,
});

export const dispatchProviderCd = (data) => ({
  type: actionTypes.SET_PROVIDER_CD,
  payload: data,
});

// dispatch claim category
export const dispatchClaimCategory = (data) => ({
  type: actionTypes.SET_CLAIM_CATEGORY,
  payload: data,
});
export const getClaimCategoryList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CLAIM_CATEGORY_DATA, value)
    .then((response) => {
      return dispatch(dispatchClaimCategory(response.data));
    })
    .catch((response) => {
      dispatch(dispatchClaimCategory([]));
    });
};
// dispatch claim category Name
export const dispatchClaimCategoryName = (data) => ({
  type: actionTypes.SET_CLAIM_NAME_CATEGORY,
  payload: data,
});
// drug data dispatch
export const dispatchDrugData = (data) => ({
  type: actionTypes.GET_DRUG_DATA_CLAIM,
  payload: data,
});
// dispatch unit grid
export const dispatchUnitData = (data) => ({
  type: actionTypes.GET_ADJUSTED_CLAIMS_UNIT_DATA,
  payload: data,
});
export const getUnitList = (value) => (dispatch) => {
  dispatch(dispatchUnitData([]));
  return axios
    .post(serviceEndPoint.GET_ADJUSTED_CLAIM_UNIT, value)
    .then((response) => {
      if (response?.data?.adjustedClaimsUnitGridVO?.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchUnitData(response.data));
      }
    })
    .catch((error) => {
      dispatch(dispatchUnitData([]));
    });
};

export const setLoadedClaimLoad = (data) => ({
  type: actionTypes.LOAD_DETAIL_SCR,
  payload: data,
});
export const dispatchLabelerSelection = (payload) => ({
  type: actionTypes.SELECTED_LABELER_M,
  payload,
});
// dispatch adjusted claim grid
export const dispatchAdjustedClaim = (data, checkboxValues) => ({
  type: actionTypes.GET_ADJUSTED_CLAIMS_GRID_DATA,
  payload: data,
  checkboxValues: checkboxValues,
});
export const getAdjustedClaimList = (value) => (dispatch) => {
  dispatch(dispatchAdjustedClaim([]));
  return axios
    .post(serviceEndPoint.GET_ADJUSTED_CLAIM_GRID, value)
    .then((response) => {
      if (response?.data?.adjustedClaimsGridVO?.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        handleExistingCommentList(
          response.data.adjustedClaimsGridVO,
          dispatch,
          dispatchAdjustedClaim
        );
      }
      return response.data.adjustedClaimsGridVO;
    })
    .catch((response) => {
      dispatch(dispatchAdjustedClaim([]));
    });
};
export const setDetailsPagination = (payload) => ({
  type: actionTypes.PAGINATION_DATA_SET,
  payload,
});
// dispatch Quarter From
export const dispatchQtrRange = (data) => ({
  type: actionTypes.SET_QUARTER_RANGE_CLAIMS,
  payload: data,
});
// dispatch Labeler Info
export const dispatchLabelerInfo = (data) => ({
  type: actionTypes.SET_LABELER_INFO,
  payload: data,
});
export const getLabelerInfoList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_LABELER_INFO_DATA, value)
    .then((response) => {
      return dispatch(dispatchLabelerInfo(response.data));
    })
    .catch((response) => {
      dispatch(dispatchLabelerInfo([]));
    });
};
// dispatch labeler info name
export const dispatchLabelerInfoName = (data) => ({
  type: actionTypes.SET_LABELER_INFO_NAME,
  payload: data,
});
// dispatch drug sequence number for selectby as ALL
export const dispatchDrugSeq = (data) => ({
  type: actionTypes.GET_ADJUSTED_CLAIMS_DRUG_DATA,
  payload: data,
});

export const getDrugSeqList = (value) => async (dispatch) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_ADJUSTED_CLAIM_DRUG,
      value
    );
    dispatch(dispatchDrugSeq(response.data));
    return response.data; // Return the response data
  } catch (error) {
    dispatch(dispatchDrugSeq([])); // Dispatch an empty array or handle errors appropriately
    throw error; // Rethrow the error to be handled by the caller
  }
};

// dispatch drug sequence detail
export const dispatchDrugSeqDetail = (data) => ({
  type: actionTypes.GET_ADJUSTED_CLAIMS_DRUG_DATA_NAME,
  payload: data,
});
// dispatch drug name as per drug sequence number
export const dispatchDrugName = (data) => ({
  type: actionTypes.GET_ADJUSTED_CLAIMS_ALL_DATA,
  payload: data,
});
export const getDrugNameList = (value) => (dispatch) => {
  dispatch(dispatchDrugName([]));
  return axios
    .post(serviceEndPoint.GET_ADJUSTED_CLAIM_ALL, value)
    .then((response) => {
      if (response.data.adjustedClaimsHeaderGridVO.length == 0) {
        // dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchDrugName(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchDrugName([]));
    });
};
